<template></template>

<script>
export default {
	beforeMount() {
		this.$emit("init");
	}
};
</script>
